import { ColorRange } from '../types';

export const ACTIVE_NODE_COLOR = '#ff7c43';

export const CHART_COLOR_RANGE: ColorRange = {
    low: '#2f4b7c',
    mid: '#665191',
    high: '#a05195',
};
